import { getFramework } from '@/framework';
import { base64Kit } from '@/utils/base64-kit';
import { deleteExtraInfo } from '@/utils/layer-kit';
import type { ILayerBehavior, ITableLayer } from '@/version-types';
import { prepareTableLayerDocumentFonts } from '../font-measurement';
import { renderLayerContentToCanvas } from '../render/render-to-canvas';
import { renderLayerToPPT } from '../render/render-to-ppt';
import { renderLayerToStage } from '../render/render-to-stage';
import { getUsingStyles } from '../utils/get-table-layer-by-xlsx';
import { getTableLayerScreenshotUrlCode } from '../utils/screenshot';

type Behaviors = Pick<
    ILayerBehavior,
    'onBeforeSaveAsync' | 'savePPTLayerAsync' | 'getResultCanvasAsync' | 'getLayerImageAsync'
>;

export const createSaveBehaviors = (frameworkIdentity: string) => {
    const prepareDocumentFonts = (layer: ITableLayer) =>
        prepareTableLayerDocumentFonts(getFramework(frameworkIdentity).service, layer);

    const behaviors: Behaviors = {
        async getLayerImageAsync(layer, globalAlpha = true) {
            const tableLayer = layer as ITableLayer;
            await prepareDocumentFonts(tableLayer);

            const canvas = await renderLayerContentToCanvas(tableLayer, { globalAlpha });
            if (!canvas) {
                throw new Error('生成图片失败, 需要排查一下');
            }
            return canvas;
        },

        async onBeforeSaveAsync(_layer) {
            const layer = _layer as ITableLayer;
            deleteExtraInfo(layer);
            layer.data.styles = getUsingStyles(layer);

            const code = await getTableLayerScreenshotUrlCode(frameworkIdentity, layer);
            layer.data.screenshotUrl = code ? await base64Kit.getRemoteUrlAsync(code) : '';
        },

        async getResultCanvasAsync(layer, resultSize) {
            const tableLayer = layer as ITableLayer;
            await prepareDocumentFonts(tableLayer);
            return renderLayerToStage(tableLayer, resultSize);
        },

        async savePPTLayerAsync(slide, layer) {
            const tableLayer = layer as ITableLayer;
            await prepareDocumentFonts(tableLayer);
            return renderLayerToPPT(slide, tableLayer);
        },
    };

    return behaviors;
};
